var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip-wrapper",class:{'normal ml-3': _vm.type === 'normal', 'hamburger' : _vm.type === 'hamburger'}},[_c('span',{staticClass:"tooltip-text",style:(_vm.fontStyle)},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }